import type { FeedbackMessages } from './en';

const nb: FeedbackMessages = {
  qualified: {
    title: 'Takk for at du gjennomførte denne undersøkelsen!',
    body1: 'Du kan nå lukke nettleservinduet.',
    body2: 'Vi håper å se deg igjen snart.',
    refCode: 'Referansekode: {code}',
  },
  quotaFull: {
    title: 'Denne undersøkelsen er avsluttet',
    body1: 'Takk for din interesse for undersøkelsen vår.',
    body2: 'Vi har dessverre allerede mottatt alle svarene vi trenger.',
    body3: 'Vi håper å se deg i en av våre fremtidige undersøkelser!',
    refCode: 'Referansekode: {code}',
  },
  terminated: {
    title: 'Takk for at du delte din tilbakemelding!',
    body1:
      'Vi håper å se deg igjen i våre fremtidige undersøkelser. Frem til da vil vi ønske deg en fin dag.',
    body2: 'Vennligst lukk dette nettleservinduet.',
    refCode: 'Referansekode: {code}',
  },
  mismatch: {
    title: 'Takk for din interesse',
    body1: 'Du er dessverre ikke i målgruppen for denne spesifikke undersøkelsen.',
    body2: 'Du kan lukke denne siden.',
    code: 'Kode: {code}',
  },
  error: {
    title: 'Vi kan ikke behandle forespørselen din',
    linkProblemDetailed:
      'Lenken du har fulgt har problemer. Kontroller at lenken i adressefeltet stemmer med den du fikk, og prøv igjen.',
    linkProblemGeneric: 'Lenken du har fulgt har problemer. Vennligst prøv igjen.',
    contactPerson:
      'Hvis problemet fortsetter, vennligst gi personen du fikk lenken fra beskjed om dette problemet.',
    errorCode: 'Feilkode: {code}',
  },
};

export default nb;
